import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import StyledGrid from './Styles';

const propTypes = {
  testId: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

const defaultProps = {
  testId: undefined,
  className: undefined,
  children: undefined
};

const Grid = ({ testId, children, className, variant }) => (
  <StyledGrid
    id="conditions-grid"
    data-testid={testId}
    className={className}
    variant={variant}
  >
    {children}
  </StyledGrid>
);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

export default styled(Grid)``;
